import { render, staticRenderFns } from "./TheStakeholderRequestPrivacyNotice.vue?vue&type=template&id=a36ccf6a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports